import React, { Component } from "react";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';
import Video from '../global/Video';

export default class ProjectRow extends Component {
  	
  	constructor(){
		super()
		this.state = {
			width: 		0,
			height: 	0,
			fWidth: 	0,
			fHeight: 	0,
			fLeft: 		0,
			fTop: 		0,
			sWidth: 	0,
			sHeight: 	0,
			sLeft: 		0,
			sTop: 		0,
			tWidth: 	0,
			tHeight: 	0,
			tTop: 		0,
			tLeft: 		0,
			margin: 	0,
		}
		this.handleResize = this.handleResize.bind(this);
	}
    
	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
	  	this.handleResize();
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
        
    handleResize() {
	  	
	  	if (document.getElementsByClassName('c-header').length > 0) {
	  		
			let dMargin 		= document.getElementsByClassName('c-header__inner')[0].offsetLeft;
			let usableWidth 	= window.innerWidth - (dMargin * 2);
			let usableHeight 	= window.innerHeight - (document.getElementsByClassName('c-header')[0].clientHeight * 1) - 34;
			
			if (this.props.first === true) {
			//	usableHeight = window.innerHeight - document.getElementsByClassName('c-project__header')[0].clientHeight - 34;
			}
			
			if (usableHeight < (usableWidth * 0.4)) {
				usableHeight = (usableWidth * 0.4);
			}
		
			let usableRatio 	= usableWidth / usableHeight;
			
			let targetWidth 	= parseInt(this.props.twidth);
			let targetHeight 	= parseInt(this.props.theight);
			let targetRatio 	= targetWidth / targetHeight;
						
			let width 	= usableWidth
			let height 	= Math.round(usableWidth / targetRatio);
			
			if (targetRatio < usableRatio) {
				width 	= Math.round(usableHeight * targetRatio);
				height 	= usableHeight;
			}			
			
			dMargin = Math.round((window.innerWidth - width) * 0.5);
						
			let blockHeight = window.innerHeight;		
			
			let fRatio 		= 0;
			let fWidth 		= 0;
			let fHeight 	= 0;
			let fLeft 		= 0;
			let fTop 		= 0;
			let sWidth  	= 0;
			let sHeight 	= 0;
			let sLeft 		= 0;
			let sTop 		= 0;
			let tWidth 		= 0;
			let tHeight 	= 0;
			let tTop 		= 0;
			let tLeft 		= 0;
			let mediaCount 	= parseInt(this.props.row.media);
			
			let gutter = 28;
			
			if (mediaCount === 3) {

				fWidth 	= Math.round((window.innerWidth * 0.333) - (dMargin * 0.666) - (28 * 0.666));
				if (fWidth < (window.innerWidth * 0.15)) {
					fWidth = (window.innerWidth * 0.15);
				}
				fHeight = Math.round(fWidth / (parseInt(this.props.row.fst_width) / parseInt(this.props.row.fst_height) ) );
				fLeft 	= Math.round((window.innerWidth * 0.5) - (fWidth * 1.5) - (gutter * 1));
				
				blockHeight = fHeight;
				
				sWidth 	= fWidth;
				sHeight = Math.round(sWidth / (parseInt(this.props.row.snd_width) / parseInt(this.props.row.snd_height) ) );
				sLeft 	= fLeft + fWidth + 28;;
				
				if (blockHeight < sHeight) {
					blockHeight = sHeight;
				}
				
				tWidth 	= fWidth;
				tHeight = Math.round(tWidth / (parseInt(this.props.row.trd_width) / parseInt(this.props.row.trd_height) ) );
				tLeft 	= fLeft + fWidth + 28 + sWidth + 28;
				
				if (blockHeight < tHeight) {
					blockHeight = tHeight;
				}
				
				/*
				if (this.props.first === true) {
					blockHeight = window.innerHeight - document.getElementsByClassName('c-project__header')[0].clientHeight;
					if (blockHeight > fHeight) {
						blockHeight = fHeight
					}
					if (blockHeight > sHeight) {
						blockHeight = sHeight
					}
					if (blockHeight > tHeight) {
						blockHeight = tHeight
					}
				}
				*/
				
				fTop = Math.round((blockHeight - fHeight) * 0.5);
				sTop = Math.round((blockHeight - sHeight) * 0.5);
				tTop = Math.round((blockHeight - tHeight) * 0.5);
				
			} else if (mediaCount === 2) {

				fWidth 	= Math.round((window.innerWidth * 0.5) - (dMargin * 1.5));
				if (fWidth < (window.innerWidth * 0.2)) {
					fWidth = (window.innerWidth * 0.2);
				}
				fHeight = Math.round(fWidth / (parseInt(this.props.row.fst_width) / parseInt(this.props.row.fst_height) ) );
				
				if (fHeight > usableHeight) {
					let fRatio = fWidth / fHeight;
					fHeight = usableHeight;
					fWidth 	= fHeight * fRatio;
				}
				
				fLeft = Math.round((window.innerWidth * 0.5) - fWidth - (gutter * 0.5));
				
				blockHeight = fHeight;
				
				sWidth 	= fWidth;
				sHeight = Math.round(sWidth / (parseInt(this.props.row.snd_width) / parseInt(this.props.row.snd_height) ) );
				
				if (sHeight > usableHeight) {
					let sRatio = sWidth / sHeight;
					sHeight = usableHeight;
					sWidth 	= sHeight * sRatio;
				}
				
				sLeft 	= fLeft + fWidth + gutter;
				
				if (blockHeight < sHeight) {
					blockHeight = sHeight;
				}
				
				/*
				if (this.props.first === true) {
					blockHeight = window.innerHeight - document.getElementsByClassName('c-project__header')[0].clientHeight;
					if (blockHeight > fHeight) {
						blockHeight = fHeight
					}
					if (blockHeight > sHeight) {
						blockHeight = sHeight
					}
				}
				*/
				
				fTop = Math.round((blockHeight - fHeight) * 0.5);
				sTop = Math.round((blockHeight - sHeight) * 0.5);

			} else if (mediaCount === 1) {
				
				fRatio 	= parseInt(this.props.row.fst_width) / parseInt(this.props.row.fst_height);
				fWidth 	= usableWidth
				fHeight = Math.round(usableWidth / fRatio);
			
				if (fRatio < usableRatio) {
					fWidth 	= Math.round(usableHeight * fRatio);
					fHeight = usableHeight;
				}
				
				if (fWidth > fHeight) {
					
					let hfWidth = Math.round((window.innerWidth * 0.5) - (dMargin * 1.5));
					if (hfWidth < (window.innerWidth * 0.15)) {
						hfWidth = (window.innerWidth * 0.15);
					}
					
					let hfHeight = Math.round(hfWidth / (1920 / 2880) );
				
					if (hfHeight > usableHeight) {
						let hfRatio = hfWidth / hfHeight;
						hfHeight = usableHeight;
						hfWidth = hfHeight * (1920 / 2880);
					}
					
					fWidth = hfWidth + hfWidth + 28;
					fHeight = Math.round(fWidth / fRatio);
				}
				
				fLeft = Math.round((window.innerWidth - fWidth) * 0.5);
				
				blockHeight = fHeight;
				/*
				if (this.props.first === true) {
					blockHeight = window.innerHeight - document.getElementsByClassName('c-project__header')[0].clientHeight;
					if (blockHeight > fHeight) {
						blockHeight = fHeight
					}
				}
				*/
				fTop = Math.round((blockHeight - fHeight) * 0.5);
			}
			
			this.setState({
				margin 	: dMargin,
				height 	: blockHeight,
				width 	: window.innerWidth - (dMargin * 1),
				fWidth 	: fWidth,
				fHeight : fHeight, 
				fLeft 	: fLeft,
				fTop 	: fTop,
				sWidth 	: sWidth,
				sHeight : sHeight,
				sLeft 	: sLeft,
				sTop 	: sTop,
				tWidth 	: tWidth,
				tHeight : tHeight,
				tTop 	: tTop,
				tLeft 	: tLeft
			});
	  	}
  	}
  	
	render() {
		
		const row = this.props.row;
		
		let rowClass = 'c-project__row c-project__row--' + row.media;
		let spaceClass = 'c-project__row-space';
		if (this.props.first === true) {
			rowClass = 'c-project__row c-project__row--first';
			spaceClass = 'c-project__row-space c-project__row-space--first';
		}
		
		if (row.media === 1 && row.fst_type == 'text') {
			rowClass = rowClass + ' c-project__row--text';
		}
		
		if (row) {
							
			return (
				
				<>			
					<div className={rowClass} style={{height: this.state.height + 'px'}}>
						
						{row.media === 3 &&
							<>
								<div className="c-project__row__media c-page__block--load-effect" style={{width:this.state.fWidth + 'px', height: this.state.fHeight + 'px', left:this.state.fLeft + 'px', top:this.state.fTop + 'px'}}>
									
									{row.fst_type == 'image' &&
										<Image width={row.fst_width} height={row.fst_height} srcset={row.fst_srcset} src={row.fst_src} />
									}
									
									{row.fst_type == 'cinemagraph' &&
										<Cinemagraph  width={row.fst_width} height={row.fst_height} src={row.fst_src} />
									}
									
									{row.fst_type == 'text' &&
										<div className="c-project__row__media__text">
											<div className="scope-project-text scope-project-text--dark" dangerouslySetInnerHTML={{__html:row.fst_text}}></div>
										</div>
									}
									
								</div>
								<div className="c-project__row__media c-page__block--load-effect" style={{width:this.state.sWidth + 'px', height: this.state.sHeight + 'px', left:this.state.sLeft + 'px', top:this.state.sTop + 'px'}}>
									
									{row.snd_type == 'image' &&
										<Image width={row.snd_width} height={row.snd_height} srcset={row.snd_srcset} src={row.snd_src} />
									}
									
									{row.snd_type == 'cinemagraph' &&
										<Cinemagraph  width={row.snd_width} height={row.snd_height} src={row.snd_src} />
									}
									
									{row.snd_type == 'text' &&
										<div className="c-project__row__media__text">
											<div className="scope-project-text scope-project-text--dark" dangerouslySetInnerHTML={{__html:row.snd_text}}></div>
										</div>
									}
									
								</div>
								<div className="c-project__row__media c-page__block--load-effect" style={{width:this.state.tWidth + 'px', height: this.state.tHeight + 'px', left:this.state.tLeft + 'px', top:this.state.tTop + 'px'}}>
									
									{row.trd_type == 'image' &&
										<Image width={row.trd_width} height={row.trd_height} srcset={row.trd_srcset} src={row.trd_src} />
									}
									
									{row.trd_type == 'cinemagraph' &&
										<Cinemagraph  width={row.trd_width} height={row.trd_height} src={row.trd_src} />
									}
									
									{row.trd_type == 'text' &&
										<div className="c-project__row__media__text">
											<div className="scope-project-text scope-project-text--dark" dangerouslySetInnerHTML={{__html:row.trd_text}}></div>
										</div>
									}
									
								</div>
							</>
						}
						{row.media === 2 &&
							<>
								<div className="c-project__row__media c-page__block--load-effect" style={{width:this.state.fWidth + 'px', height: this.state.fHeight + 'px', left:this.state.fLeft + 'px', top:this.state.fTop + 'px'}}>
									
									{row.fst_type == 'image' &&
										<Image width={row.fst_width} height={row.fst_height} srcset={row.fst_srcset} src={row.fst_src} />
									}
									
									{row.fst_type == 'cinemagraph' &&
										<Cinemagraph  width={row.fst_width} height={row.fst_height} src={row.fst_src} />
									}
									
									{row.fst_type == 'video' &&
										<Video  width={row.fst_width} height={row.fst_height} src={row.fst_src} poster={row.fst_poster} />
									}
									
									{row.fst_type == 'text' &&
										<div className="c-project__row__media__text">
											<div className="scope-project-text scope-project-text--dark" dangerouslySetInnerHTML={{__html:row.fst_text}}></div>
										</div>
									}
									
								</div>
								<div className="c-project__row__media" style={{width:this.state.sWidth + 'px', height: this.state.sHeight + 'px', left:this.state.sLeft + 'px', top:this.state.sTop + 'px'}}>
									
									{row.snd_type == 'image' &&
										<Image width={row.snd_width} height={row.snd_height} srcset={row.snd_srcset} src={row.snd_src} />
									}
									
									{row.snd_type == 'cinemagraph' &&
										<Cinemagraph  width={row.snd_width} height={row.snd_height} src={row.snd_src} />
									}
									
									{row.snd_type == 'video' &&
										<Video  width={row.snd_width} height={row.snd_height} src={row.snd_src} poster={row.snd_poster} />
									}
									
									{row.snd_type == 'text' &&
										<div className="c-project__row__media__text">
											<div className="scope-project-text scope-project-text--dark" dangerouslySetInnerHTML={{__html:row.snd_text}}></div>
										</div>
									}
									
								</div>
							</>
						}
						{row.media === 1 &&
							<>
								{row.fst_type == 'text' &&
									
									<div className="c-project__row__media c-page__block--load-effect">
										
										{row.fst_type == 'text' &&
											<div className="c-project__row__media__text">
												<div className="scope-project-text scope-project-text--dark" dangerouslySetInnerHTML={{__html:row.fst_text}}></div>
											</div>
										}
										
									</div>
								
								}
								
								{row.fst_type != 'text' &&
									
									<div className="c-project__row__media c-page__block--load-effect" style={{width:this.state.fWidth + 'px', height: this.state.fHeight + 'px', left:this.state.fLeft + 'px', top:this.state.fTop + 'px'}}>
										
										{row.fst_type == 'image' &&
											<Image width={row.fst_width} height={row.fst_height} srcset={row.fst_srcset} src={row.fst_src} />
										}
										
										{row.fst_type == 'cinemagraph' &&
											<Cinemagraph  width={row.fst_width} height={row.fst_height} src={row.fst_src} />
										}
										
										{row.fst_type == 'video' &&
											<Video  width={row.fst_width} height={row.fst_height} src={row.fst_src} poster={row.fst_poster} />
										}
										
									</div>
									
								}
								
							</>
						}
						
					</div>
					
					<div className={spaceClass}></div>
				</>
			)
					
		} else {
			
			return null;
			
		}
		
	}
							
}